import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import { resetStore } from '@/plugins/vue-apollo';
import { UserType } from '@/helpers/entities/enums/UserType';
import Me from '@/plugins/graphql/queries/me.gql';
import DestroyToken from '@/plugins/graphql/mutations/v2/auth/destroy-token.gql';
import { AWS_SL_SAML_LOGOUT_URL, IDLE_TIMESTAMP, IDLE_TIMESTAMP_TO } from '@/helpers/constants/app';
import WhiteLabelRedirectMixin from '@/helpers/mixins/WhiteLabelRedirectMixin';
let LogoutMixin = class LogoutMixin extends Mixins(WhiteLabelRedirectMixin) {
    constructor() {
        super(...arguments);
        this.role = '';
    }
    removeSessionTimestamps() {
        localStorage.removeItem(IDLE_TIMESTAMP);
        localStorage.removeItem(IDLE_TIMESTAMP_TO);
    }
    logout(path = null) {
        resetStore().then(() => {
            // remove any persistent error message alert
            this.$store.commit('toggleAlert', false);
            this.$store.commit('clearAlertMessage');
            localStorage.clear();
            this.$store.commit('session/logout');
            this.$emit('dismissed');
            if (this.role === UserType.Cognito) {
                this.cognitoRedirect();
            }
            else if (this.role === UserType.Affiliate) {
                this.affiliateRedirect();
            }
            else {
                this.redirectActions(path);
            }
            this.removeSessionTimestamps();
            this.closeDrawer();
        });
    }
    closeDrawer() {
        this.$store.commit('navigation_drawer/toggleDrawer', false);
    }
    destroyToken(token) {
        const vm = this;
        if (vm.$store.state.session.authenticated) {
            return this.$apollo.mutate({
                mutation: DestroyToken,
                variables: {
                    input: {
                        token,
                    },
                },
            });
        }
    }
    cognitoRedirect() {
        window.location.href = AWS_SL_SAML_LOGOUT_URL;
    }
    affiliateRedirect() {
        this.$router.push('/login/affiliate');
    }
};
LogoutMixin = __decorate([
    Component({
        apollo: {
            role: {
                query: Me,
                update: (data) => {
                    return data.me?.role;
                },
                skip() {
                    return !this.$store.state.session.token;
                },
            },
        },
    })
], LogoutMixin);
export default LogoutMixin;
